import { useEffect, useState } from "react";
import {
  LuLibrary,
  LuArrowRight,
  LuChevronLeft,
  LuChevronRight,
  LuMoreHorizontal,
  LuSearch,
} from "react-icons/lu";
import { ParamInterface } from "../../../interface-and-types";
import Preloader from "../../../app-components/preloader/Preloader";
import apiClient from "../../../api-services/ApiClient";
import { Link } from "react-router-dom";
// import { SITELINKS } from "../../../app-routes/links";
import { formatDate } from "../../../helpers";
import { SITELINKS } from "../../../app-routes/links";

const AdminActionTracker = () => {
  const [actionTracker, setActionTracker] = useState<any[]>([]);
  const [closeOutActions, setCloseOutActions] = useState<any[]>([]);
  const [searchInputDebounce, setSearchInputDebounce] = useState<string>("");
  const [searchInput, setSearchInput] = useState<string>("");
  const [status, setStatus] = useState<string>("");
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(0);
  const [loading, setLoading] = useState<boolean>(false);

  // getActionTracker
  useEffect(() => {
    const params = {
      page: currentPage,
      SearchString: searchInput,
      OrderBy: "Descending",
      FilterByStatus: status,
      PageSize: 10,
    };

    getActionTracker(params);
  }, [currentPage, searchInput, status]);

  // debounce search input
  useEffect(() => {
    const handler = setTimeout(() => {
      setSearchInput(searchInputDebounce);
      setCurrentPage(1);
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [searchInputDebounce]);

  useEffect(() => {
    getCloseOutActions();
  }, []);

  // getActionTracker fn
  const getActionTracker = async (params: ParamInterface) => {
    setLoading(true);

    try {
      const res: any = await apiClient.get("ActionTracker", { params });
      if (res && res.data) {
        setActionTracker(res.data.data);
        setCurrentPage(res.data.pageIndex);
        setLastPage(res.data.totalPages);
      } else {
        setActionTracker([]);
      }
    } catch (error) {
      console.error("Error fetching Inspection Form:", error);
      setActionTracker([]);
    } finally {
      setLoading(false);
    }
  };

  // Handle Previous
  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Handle Next
  const handleNext = () => {
    if (currentPage < lastPage) {
      setCurrentPage(currentPage + 1);
    }
  };

  // getActionTracker fn
  const getCloseOutActions = async () => {
    setLoading(true);

    try {
      const res: any = await apiClient.get("Constants/CloseOutActions");
      if (res && res.data) {
        setCloseOutActions(res.data.data);
      } else {
        setCloseOutActions([]);
      }
    } catch (error) {
      console.error("Error fetching Inspection Form:", error);
      setCloseOutActions([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* page lead */}
      <section className="flex justify-between items-center bg-gradient-to-r from-secondaryBlue to-primaryBlue shadow-md border-b border-gray-200">
        <div className="xl:container xl:mx-auto md:px-4 py-4 pb-24 flex justify-between items-center">
          <h4 className="lg:text-[16px] text-white nunito font-medium">
            Action Tracker
          </h4>
        </div>
      </section>

      {/* page content */}
      <section className="pt-5 mx-auto md:px-4 xl:container relative top-[-100px] xl:top-[-90px]">
        <div className="rounded-lg pb-6 bg-white shadow-sm">
          {/* page filter && search */}
          <div className="p-3 flex justify-between">
            <div className="relative xl:w-1/3 w-1/2">
              <input
                value={searchInputDebounce}
                onChange={(e) => setSearchInputDebounce(e.target.value)}
                placeholder="Search by vessel name, equipment name"
                className="p-2 border text-sm border-gray-300 hover:border-blue-400 rounded-lg w-full"
              />
              <LuSearch className="text-lg top-[10px] absolute right-[9px] text-gray-400" />
            </div>

            <div>
              <select
                onChange={(e) => {
                  setStatus(e.target.value);
                }}
                className="p-2 text-xs border border-gray-300 hover:border-blue-400 rounded-lg"
              >
                <option>All Status</option>
                {closeOutActions.map((item: any) => (
                  <option value={item.value}>{item.name}</option>
                ))}
              </select>
            </div>
          </div>

          {/* record TABLE */}
          <div className="overflow-x-auto mb-5 overflow-y-auto">
            <table className="min-w-full bg-white mb-4">
              <thead>
                <tr className="w-full bg-gray-200 text-gray-600 capitalize text-xs leading-normal border-b">
                  <th className="py-3 px-3 text-left">Vessel name</th>
                  <th className="py-3 px-3 text-left">Equipment Name</th>
                  <th className="py-3 px-3 text-left">Date Reported</th>
                  <th className="py-3 px-3 text-left">Critical Equipment</th>
                  <th className="py-3 px-3 text-left">Type of Defect</th>
                  <th className="py-3 px-3 text-left">Defect Category</th>
                  <th className="py-3 px-3 text-left">Close-Out Status</th>
                  <th className="py-3 px-3 text-left">Actions</th>
                </tr>
              </thead>

              {!!actionTracker?.length && (
                <tbody className="text-gray-600 text-xs font-light">
                  {actionTracker?.map((inspection: any, i: number) => {
                    return (
                      <tr
                        key={inspection.id}
                        className={`border-b border-[#F2F1F1] hover:bg-gray-100 font-normal text-slate-700`}
                      >
                        <td className="py-3 px-3 text-left">
                          {inspection?.vesselDefectCheckList?.vessel?.name ??
                            ""}
                        </td>

                        <td className="py-3 px-3 text-left">
                          {inspection?.vesselDefectCheckList?.equipment?.name ??
                            ""}
                        </td>

                        <td className="py-3 px-3 text-left">
                          {inspection?.vesselDefectCheckList?.createdAt
                            ? formatDate(
                                inspection?.vesselDefectCheckList?.createdAt,
                                "date"
                              )
                            : ""}
                        </td>

                        <td className="py-3 px-3 text-left">
                          {inspection?.vesselDefectCheckList
                            ?.criticalEquipment ?? ""}{" "}
                        </td>

                        <td className="py-3 px-3 text-left">
                          {inspection?.vesselDefectCheckList?.defectType
                            ?.name ?? ""}
                        </td>

                        <td className="py-3 px-3 text-left">
                          {inspection?.vesselDefectCheckList
                            ?.priorityDescription ?? ""}{" "}
                          ({inspection?.vesselDefectCheckList?.priority ?? ""})
                        </td>

                        <td className="py-3 px-3 text-left">
                          {inspection?.closeOutAction ?? ""}
                        </td>

                        <td className="py-3 px-3 text-left flex gap-4 items-left">
                          <Link
                            to={`${SITELINKS.ADMIN_VIEW_TRACKER}/${inspection.id}`}
                            state={{
                              formType: inspection?.inspectionType?.name ?? "",
                            }}
                            className={`font-medium flex gap-1 items-center text-red-600`}
                          >
                            <span>View</span>
                            <LuArrowRight className="text-lg" />
                          </Link>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              )}
            </table>

            {!actionTracker?.length && (
              <div className="text-center p-5 text-sm text-gray-500 ">
                <LuLibrary className="text-[50px] w-full" />
                <p> No record found</p>
              </div>
            )}
          </div>

          {/* <!-- ROW PAGINATION --> */}
          <div className="flex justify-center gap-3 flex-wrap">
            {/* Previous Button */}
            <button
              onClick={handlePrevious}
              disabled={currentPage === 1}
              className={`bg-[#fff] text-gray-500 text-xs p-1 px-2 rounded-lg border-2 border-solid border-[#F2F1F1] font-normal ${
                currentPage === 1
                  ? "disabled:text-gray-400 disabled:cursor-not-allowed"
                  : ""
              }`}
            >
              <span>Previous</span>
            </button>

            {/* Left Arrow */}
            <button
              disabled={currentPage === 1}
              onClick={handlePrevious}
              className={`bg-[#fff] text-gray-400 p-1 px-2 rounded-lg border-2 border-solid border-[#F2F1F1] text-base font-medium ${
                currentPage === 1
                  ? "disabled:text-gray-400 disabled:cursor-not-allowed"
                  : ""
              }`}
            >
              <LuChevronLeft className="text-xl" />
            </button>

            {/* Page Numbers */}
            {Array.from(
              { length: lastPage > 7 ? 3 : lastPage },
              (_, i) => i + 1
            ).map((page) => (
              <button
                title={`page ${page}`}
                key={page}
                onClick={() => setCurrentPage(page)}
                className={`p-1 px-3 rounded-lg border-2 border-solid border-[#F2F1F1] font-normal text-xs ${
                  page === currentPage
                    ? "bg-red-600 text-white"
                    : "bg-[#fff] text-gray-600"
                }`}
              >
                <span>{page}</span>
              </button>
            ))}

            {lastPage > 7 && (
              <>
                {/* ellipse Arrow */}
                <button
                  disabled
                  className={`bg-[#fff] text-gray-600 p-1 px-2 rounded-lg border-2 border-solid border-[#F2F1F1]`}
                >
                  <LuMoreHorizontal className="text-xl" />
                </button>

                {/* Page Numbers */}
                {Array.from({ length: 3 }, (_, i) => 2 - i).map((page) => (
                  <button
                    title={`page ${lastPage - page}`}
                    key={lastPage - page}
                    onClick={() => setCurrentPage(lastPage - page)}
                    className={`p-1 px-3 rounded-lg border-2 border-solid border-[#F2F1F1] text-base font-normal text-xs ${
                      lastPage - page === currentPage
                        ? "bg-red-600 text-white"
                        : "bg-[#fff] text-gray-600"
                    }`}
                  >
                    <span>{lastPage - page}</span>
                  </button>
                ))}
              </>
            )}

            {/* Right Arrow */}
            <button
              disabled={currentPage === lastPage}
              onClick={handleNext}
              className={`bg-[#fff] text-gray-400 p-1 px-2 rounded-lg border-2 border-solid border-[#F2F1F1] ${
                currentPage === lastPage
                  ? "disabled:text-gray-400 disabled:cursor-not-allowed"
                  : ""
              }`}
            >
              <LuChevronRight className="text-xl" />
            </button>

            {/* Next Button */}
            <button
              onClick={handleNext}
              disabled={currentPage === lastPage}
              className={`bg-[#fff] text-gray-500 text-xs p-1 px-2 rounded-lg border-2 border-solid border-[#F2F1F1] font-normal ${
                currentPage === lastPage
                  ? "disabled:text-gray-400 disabled:cursor-not-allowed"
                  : ""
              }`}
            >
              <span>Next</span>
            </button>
          </div>
        </div>
      </section>

      <Preloader loading={loading} />
    </>
  );
};

export default AdminActionTracker;
